import { NOTIFICATION, NOTIFICATION_PERMISSIONS, NOTIFICATION_TITLE } from '../services/const';

export const requestNotificationPermission = async () => {
    if (!(NOTIFICATION in window)) {
        alert("This browser does not support desktop notifications.");
        return;
    }

    if (Notification.permission === NOTIFICATION_PERMISSIONS.DEFAULT) {
        await Notification.requestPermission();
    }
};

export const showNotification = (options?: NotificationOptions) => {
    if (Notification.permission === NOTIFICATION_PERMISSIONS.GRANTED) {
        new Notification(NOTIFICATION_TITLE, {
            ...options,
            icon: '../../waymore-logo-full.svg'
        });
    } else {
        console.warn("Notifications are not enabled.");
    }
};
